<template>
  <!--Waiting for Vue 3 for multiply slots refactoring-->
  <div class="v-social-network__wrapper">
    <span class="icon-wrapper" v-for="sn in socialNetworks">
      <a :href="getSocialNetworkUrl(sn)" target="_blank">
        <img v-if="getIcon(sn)" :src="getIcon(sn)" alt="sn" />
      </a>
    </span>
  </div>
</template>

<script>
import Vue from "vue";
import VueTypes from "vue-types";

//Available SN icons in assets/images/social-networks
const SOCIAL_NETWORKS = {
  facebook: "https://www.facebook.com/inkit/",
  twitter: "https://twitter.com/inkithq",
  instagram: "https://www.linkedin.com/company/inkit/"
};

export default Vue.component("VSocialNetworkIcons", {
  props: {
    socialNetworks: VueTypes.array,
  },

  data() {
    return {
      socialNetworksLabels: null
    }
  },

  methods: {
    getIcon(sn) {
      const iconName = sn.toLowerCase();
      if (this.socialNetworksLabels.includes(iconName)) {
        return require(`@/assets/images/social-networks/${iconName}.svg`);
      }
      return false;
    },

    getSocialNetworkUrl(sn) {
      return SOCIAL_NETWORKS[sn];
    }
  },

  mounted() {
    this.socialNetworksLabels = Object.keys(SOCIAL_NETWORKS)
  }
});
</script>

<style lang="scss" scoped>
$ns: "v-social-network";
.#{$ns}__wrapper {
  .icon-wrapper {
    display: inline-block;
    margin-right: 30px;
  }
  :last-child {
    margin-right: 0;
  }
}
</style>
